import {
  AssigmentSpecialPermission,
  RequestAssigmentSpecialPermission,
} from "interfaces";
import { get, post } from "services/services.methods";
import { AssigmentSpecialPermissionPath } from "services/services.paths";

export const FetchUserByCompanySpecialPermission = async (
  idCompany: number
) => {
  const response = get<AssigmentSpecialPermission[]>(
    AssigmentSpecialPermissionPath.get + `${idCompany}`
  );

  return response;
};

export const CreateAssignSpecialPermission = async (
  data: RequestAssigmentSpecialPermission
) => {
  const response = post<any>(AssigmentSpecialPermissionPath.post, data);
  return response;
};
